import { render, staticRenderFns } from "./CustomerIntegrationForm.vue?vue&type=template&id=50707537"
import script from "./CustomerIntegrationForm.vue?vue&type=script&lang=js"
export * from "./CustomerIntegrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports